var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Weight 400"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5705_50756",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5705_50756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "medical_information",
    d: "M5.83366 14.9998H7.50033V13.3332H9.16699V11.6665H7.50033V9.99984H5.83366V11.6665H4.16699V13.3332H5.83366V14.9998ZM10.8337 12.0832H15.8337V10.8332H10.8337V12.0832ZM10.8337 14.5832H14.167V13.3332H10.8337V14.5832ZM3.33366 18.3332C2.87533 18.3332 2.48296 18.17 2.15658 17.8436C1.83019 17.5172 1.66699 17.1248 1.66699 16.6665V7.49984C1.66699 7.0415 1.83019 6.64914 2.15658 6.32275C2.48296 5.99637 2.87533 5.83317 3.33366 5.83317H7.50033V3.33317C7.50033 2.87484 7.66352 2.48248 7.98991 2.15609C8.3163 1.8297 8.70866 1.6665 9.16699 1.6665H10.8337C11.292 1.6665 11.6844 1.8297 12.0107 2.15609C12.3371 2.48248 12.5003 2.87484 12.5003 3.33317V5.83317H16.667C17.1253 5.83317 17.5177 5.99637 17.8441 6.32275C18.1705 6.64914 18.3337 7.0415 18.3337 7.49984V16.6665C18.3337 17.1248 18.1705 17.5172 17.8441 17.8436C17.5177 18.17 17.1253 18.3332 16.667 18.3332H3.33366ZM3.33366 16.6665H16.667V7.49984H12.5003C12.5003 7.95817 12.3371 8.35053 12.0107 8.67692C11.6844 9.00331 11.292 9.1665 10.8337 9.1665H9.16699C8.70866 9.1665 8.3163 9.00331 7.98991 8.67692C7.66352 8.35053 7.50033 7.95817 7.50033 7.49984H3.33366V16.6665ZM9.16699 7.49984H10.8337V3.33317H9.16699V7.49984Z",
    fill: "#475467"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.8c47b9060740f967b734283888a3ad88.svg";
export { ForwardRef as ReactComponent };